import React, { ReactNode } from "react";

type SubHeaderProp = {
  minTextSize?: string,
  children: ReactNode;
  position?: string;
};
const SubHeader = ({ children, position }: SubHeaderProp) => {
  let place = "";
  switch (position) {
    case "start":
      place = "start";
      break;
    case "center":
      place = "center";
      break;
    case "end":
      place = "end";
      break;
    default:
      place = "center";
      break;
  }
  return (
    <h1
      className={`font-barlowLight tracking-[2.5px] text-${place} text-[10px] mb-lg:text-[12px] switch:text-[16px] lg:text-[24px]`}
    >
      {children}
    </h1>
  );
};

export default SubHeader;
